<script lang="ts" setup>
import { computed } from 'vue'
import { FarmFireRiskChartTooltipFactory } from '../factories/FarmFireRiskChartTooltip.factory'
import { RecentFireRisk } from '@/@core/fire-risk-dashboard/domain/entities/RecentFireRisk'

const { farm } = defineProps<{
	farm: RecentFireRisk
}>()

const tooltipInfo = computed(() => FarmFireRiskChartTooltipFactory.make(farm))
</script>

<template>
	<div class="p-2 flex flex-col gap-2">
		<div class="flex items-center">
			<div class="flex items-center gap-2">
				<div
					class="w-3 h-3 rounded-full"
					:style="{ backgroundColor: tooltipInfo.color }"
				></div>
				<p class="text-s-bold capitalize">{{ tooltipInfo.risk }}</p>
			</div>
			<p class="text-s-bold">{{ tooltipInfo.fmaPlus.toFixed(2) }}</p>
		</div>
		<p class="text-s">{{ tooltipInfo.dateLabel }}</p>
		<p class="text-s">{{ tooltipInfo.farm }}</p>
	</div>
</template>
